__turbopack_context__.v({
  "bold": "HhrdyW_bold",
  "container": "HhrdyW_container",
  "row": "HhrdyW_row",
});
